// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__YCpqn","notfound":"Cards_notfound__M8oCe"};